module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myoutput-list",
    class: {
      active: _vm.isActive
    },
    on: {
      "mouseenter": function($event) {
        return _vm.changeActive(true)
      },
      "mouseleave": function($event) {
        return _vm.changeActive(false)
      }
    }
  }, [_c('div', {
    staticClass: "myoutput-list-header"
  }, [_c('span', {
    staticClass: "status-title"
  }, [_vm._v(_vm._s(_vm.mark) + " " + _vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selected = !_vm.selected
      }
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-minus-square-o': _vm.selected,
      'fa-plus-square-o': !_vm.selected
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "hovicon",
    on: {
      "click": function($event) {
        return _vm.calcu();
      }
    }
  }, [_vm._v("计算")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "myoutput-list-body"
  }, _vm._l((_vm.statusui.value), function(item, index) {
    return _c('div', {
      staticClass: "input-group input-group-sm"
    }, [_c('span', {
      staticClass: "input-group-addon input-group-addon-color"
    }, [_vm._v(_vm._s(item.desc) + _vm._s(index) + " "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "change": function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "checked", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "mynumber",
        rawName: "v-mynumber",
        value: ({
          class: ''
        }),
        expression: "{class:''}"
      }],
      staticClass: "form-control my-form-control",
      attrs: {
        "type": "number",
        "disabled": !item.checked,
        "min": item.min,
        "max": item.max,
        "title": item.unit,
        "step": item.step
      },
      domProps: {
        "value": (_vm.value[index] * item.conversion).toFixed(2)
      },
      on: {
        "input": function($event) {
          _vm.value[index] = $event.target.value / item.conversion
        }
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6216818b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/status.vue
// module id = 97
// module chunks = 0